/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import * as Sentry from "@sentry/react";
import { isElectron } from "react-device-detect";

import { ViennaUser } from "@vienna/common";

export const initSentry = (currentUser: ViennaUser): void => {
  Sentry.setUser({
    id: currentUser.id,
    username: currentUser?.username,
    email: currentUser.email,
    ip_address: "{{auto}}",
  });

  Sentry.setContext("vht_env", {
    isElectron,
  });
};
